import { BaseAPI } from '../BaseAPI'

export abstract class ExternalAPI extends BaseAPI {
  baseAddress =
    process.env.REACT_APP_EXTERNAL_API_BASE_URL ||
    'https://api-dev.rhodium24.io'
}
